import { IS_LENND_ADMIN, IS_SUPER_ADMIN } from "./feature-flags";
import { selectFeatureFlag } from "redux/modules/lenndFlags";

export const isAdminUser = state => {
  return (
    selectFeatureFlag(IS_LENND_ADMIN.NAME)(state) ||
    selectFeatureFlag(IS_SUPER_ADMIN.NAME)(state)
  );
};
